import React, { useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import People from "./people";
import Tutorials from "./tutorials";
import Activities from "./Activities";
import MyProfile from "./MyProfile";
import MySkills from "./MySkills";
import Snake from "./snake";
import Modal from "../../components/modal";

const Home = () => {
  const [snakeModalOpen, setSnakeModalOpen] = useState(false);
  const user = useSelector((state) => state.Auth.user);

  if (user.role === "applicant") return <Navigate to="/applicant" />;
  if (user.role === "client") return <Navigate to="/project" />;

  return (
    <div className="p-3 flex flex-col w-full h-full">
      <div className="flex gap-4 mb-3">
        <MyProfile />
        <div className="flex-1">
          <Activities />
        </div>
      </div>
      <div className="w-full">
        <People />
      </div>
      <div className="w-full flex justify-center my-4">
        <button onClick={() => setSnakeModalOpen(true)} className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 flex items-center">
          Play Snake Game
        </button>
      </div>

      <Modal isOpen={snakeModalOpen} onClose={() => setSnakeModalOpen(false)} className="w-[calc(100vw-16rem)] h-[calc(100vh-2rem)]">
        <div className="p-4">
          <h2 className="text-xl font-bold mb-4 text-center">Snake Game</h2>
          <Snake />
        </div>
      </Modal>
    </div>
  );
};

export default Home;
